import VerticalBar from "./VerticalBar";

export default VerticalBar;
